import React, { ReactNode } from 'react';

import { InfoCardLabel, InfoCardValue } from 'common/components/Card/InfoCard';
import { Item } from 'common/components/Card/InfoCard/InfoCard.styled';
import { truncatedSentence } from 'common/helpers';

interface IProps {
  label?: string;
  value?: string | number | ReactNode;
  highlight?: boolean;
  children?: ReactNode;
  padding?: string;
  border?: string;
}

export const InfoCardItem = ({
  label,
  value,
  highlight = false,
  children,
  padding,
  border,
}: IProps) => {
  return (
    <Item padding={padding} border={border}>
      {label && <InfoCardLabel label={label} highlight={highlight} />}

      {value && (
        <InfoCardValue
          value={truncatedSentence({ sentence: value as string, truncatedLength: 40 })}
        />
      )}

      {children}
    </Item>
  );
};
